export const search = {
    method: 'GET',
    paths: ['/api/orgs/:orgId/locations/:locationId/orders/search'],
    fields: {
        query: {
            type: 'keyString',
            required: true,
        },
    },
};
//# sourceMappingURL=orders_search.js.map